import React from 'react';
import {Alert, Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import _ from 'lodash';
import {Link} from "react-router-dom";

import MeteorContext from "../meteorContext";

class CreateUserModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username : "",
            password : "",
            isLocked : false,
            error : null
        };

        this.onUsernameChanged = this.onUsernameChanged.bind(this);
        this.onPasswordChanged = this.onPasswordChanged.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onCreate = this.onCreate.bind(this);
    }

    onCancel(event) {
        this.closeModal();
    }

    onUsernameChanged(event) {
        this.setState({username : event.target.value});
    }

    onPasswordChanged(event) {
        this.setState({password : event.target.value});
    }

    onCreate(event) {
        if (this.state.password.length < 5) {
            this.setState({error : {
                    title : "Passwords too short.",
                    text : "The password has to be at least 5 characters."
                }});

        } else {
            this.setState({isLocked: true});
            return MeteorContext.createUser(this.state.username, this.state.password, (_err) => {
                if(_err) {
                    this.setState({
                        isLocked : false,
                        error : {
                            title : _err.code+": "+_err.message,
                            text : ""
                        }
                    });
                } else {
                    this.closeModal()
                }

            });
        }
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    closeModal() {
        this.setState({ username: "", password: "", isLocked: false, error: null});
        if (this.props.onClose && typeof this.props.onClose === 'function') {
            this.props.onClose();
        }
    }



    render() {
        const modalProps = _.omit(this.props, ['target']);

        return (
            <Modal { ...modalProps } isOpen={ this.props.isOpen } toggle={ this.onCancel } >
                <ModalHeader tag="h6">
                                <span className="text-info">
                                    Create User
                                </span>
                    <span className="small ml-1 text-muted">
                                    Please enter username and password
                                </span>
                </ModalHeader>
                <ModalBody>
                    {
                        (() => {
                            if (this.state.error) {
                                return (
                                    <Alert color="danger">
                                        <i className="fa fa-times-circle mr-1 alert-icon"></i>
                                        <span>
                                            <strong className="alert-heading">{this.state.error.title}</strong> {this.state.error.text}
                                        </span>
                                    </Alert>
                                );
                            }
                        })()
                    }
                    <Form className="mb-3">
                        <FormGroup>
                            <Label for="username">
                                Username:
                            </Label>
                            <Input type="username" name="username" id="username" placeholder="Enter Username..." value={this.state.username} onChange={this.onUsernameChanged} disabled={this.state.isLocked} />
                        </FormGroup>
                        <FormGroup>
                            <Label for="password">
                                Password:
                            </Label>
                            <Input type="password" name="password" id="password" placeholder="Enter password..." value={this.state.password} onChange={this.onPasswordChanged} disabled={this.state.isLocked} />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" tag = { Link } disabled={this.state.isLocked} onClick={this.onCancel}>
                        Cancel
                    </Button>
                    <Button color="info" tag={ Link }  disabled={this.state.isLocked} onClick={this.onCreate}>
                        {(() => {
                            if (this.state.isLocked) {
                                return (<i className="fa fa-fw fa-refresh" style={{animation: "fa-spin 1.5s linear infinite"}} />);
                            }
                        })()}
                        { this.state.isLocked ? 'Creating ...' : "Create" }
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default CreateUserModal;